import { MutableRefObject, useState } from 'react';
import { CriticalSystem, CriticalSystemType } from '@/types/CriticalInfo';
import { ADDABLE_SYSTEMS, groupSystemsByCategory, isGroupDocumented } from '@/utils/criticalInfoUtils';

interface UseCriticalInfoCardsProps {
	systems: CriticalSystem[];
	documentedSystemNames?: Set<string>;
	systemRefs?: MutableRefObject<Record<string, HTMLDivElement | null>>;
	canEdit: boolean;
	addSystem: (name: string, type?: CriticalSystemType) => void;
}

export const useCriticalInfoCards = (props: UseCriticalInfoCardsProps) => {
	const { systems, documentedSystemNames, systemRefs, canEdit, addSystem } = props;
	const [expandedGroupSystem, setExpandedGroupSystem] = useState<string | null>(null);

	const systemGroups = groupSystemsByCategory(systems);
	const existingSystems = systemGroups.map((group) => group.categoryName);
	const availableSystems = ADDABLE_SYSTEMS.filter((system) => !existingSystems.includes(system.name));

	const isGroupFilled = (groupSystems: CriticalSystem[]) =>
		documentedSystemNames
			? groupSystems.some((system) => documentedSystemNames.has(system.name))
			: isGroupDocumented(groupSystems);

	const handleAddSystem = (name: string, type?: CriticalSystemType) => {
		if (!canEdit) return;
		addSystem(name, type);
		setExpandedGroupSystem(name);
	};

	const setGroupRef = (categoryName: string, groupSystems: CriticalSystem[], node: HTMLDivElement | null) => {
		if (!systemRefs) return;
		systemRefs.current[categoryName] = node;
		groupSystems.forEach((system) => {
			systemRefs.current[system.name] = node;
		});
	};

	return {
		systemGroups,
		availableSystems,
		existingSystems,
		expandedGroupSystem,
		setExpandedGroupSystem,
		handleAddSystem,
		isGroupFilled,
		setGroupRef,
	};
};
